import * as React from 'react'
import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { useCustomAxios } from '../../axiosInstance'
import Input from '../../components/Input/Input'
import { Box, Button, MenuItem, Select, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Loader from '../../components/Loader/loader'
import {
    ACCOUNT_ENDPOINTS,
    LOGINQA_ENDPOINTS,
    REGISTER_ENDPOINTS,
} from '../../constants/apiConstants'
import { retryAsyncFunction } from '../../util/retryAsyncFunction'
import MaskedInput from '../../components/MaskedInput/MaskedInput'
import { useNavigate } from 'react-router-dom'
import { NAVIGATION_LINKS } from '../../constants/routeConstants'

function CustomTabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}>
            {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
        </div>
    )
}

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const Myaccount = ({ setUser }) => {
    const axios = useCustomAxios()
    const [email, setEmail] = useState('')
    const navigate = useNavigate()
    const [salutation, setSalutation] = useState('')
    const [firstName, setFirstName] = useState('')
    const [lastName, setLastName] = useState('')
    const [middleName, setMiddleName] = useState('')
    const [suffix, setSuffix] = useState(0)
    const [suffixlist, setSuffixlist] = useState(null)
    const [questionlist, setQuestionlist] = useState(null)
    const [phone, setPhone] = useState('')
    const [password, setPassword] = useState('')
    const [passwordAgain, setPasswordAgain] = useState('')
    const [checkpassword, setCheckpassword] = useState(false)
    const [question, setQuestion] = useState([
        { loginQuestionId: 2, answer: '' },
        { loginQuestionId: 4, answer: '' },
        { loginQuestionId: 7, answer: '' },
    ])
    const [userQA, setUserQA] = useState([])
    const [loadingData, setLoadingData] = useState(false)
    const [value, setValue] = React.useState(0)

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        let isSubscribed = true
        window.scrollTo(0, 0)
        setLoadingData(true)

        const user = sessionStorage.getItem('user')
        let userData = JSON.parse(user)
        if (!userData.hasProfile) {
            navigate(NAVIGATION_LINKS.UPDATEPROFILE, {
                replace: true,
            })
        }

        const fetchData = () =>
            retryAsyncFunction(
                () =>
                    axios
                        .get(ACCOUNT_ENDPOINTS.ACCOUNT)
                        .then((response) => response.data),
                3,
                (err) =>
                    toastError("Something went wrong, couldn't fetch user data")
            )

        const fetchque = () =>
            retryAsyncFunction(
                () =>
                    axios
                        .get(REGISTER_ENDPOINTS.GETALLSUFFIX)
                        .then((response) => response.data),
                3,
                (err) =>
                    toastError("Something went wrong, couldn't fetch suffixes")
            )

        const fetchque1 = () =>
            retryAsyncFunction(
                () =>
                    axios
                        .get(LOGINQA_ENDPOINTS.ALL)
                        .then((response) => response.data),
                3,
                (err) =>
                    toastError("Something went wrong, couldn't fetch questions")
            )

        Promise.all([fetchData(), fetchque(), fetchque1()])
            .then((results) => {
                if (!isSubscribed) return

                const [userData, suffixes, questions] = results
                // Assuming setting state functions like setUserQA, setEmail, etc., are safely callable
                if (userData) {
                    setUserQA(userData.securityQuestions)
                    setEmail(userData.email)
                    setFirstName(userData.firstName)
                    setLastName(userData.lastName)
                    setMiddleName(userData.middleName)
                    setPhone(userData.phoneNumber)
                    setSuffix(userData.suffixId)
                    setSalutation(userData.title)
                }
                if (suffixes) {
                    setSuffixlist(suffixes)
                    // Set suffix list state updates here
                }
                if (questions) {
                    setQuestionlist(questions)
                    // Set question list state updates here
                }
            })
            .catch((error) => {
                toastError("Something went wrong, couldn't fetch any data")
            })
            .finally(() => {
                if (isSubscribed) setLoadingData(false) // Ensure loading state is updated regardless of success or failure
            })

        return () => {
            isSubscribed = false
        }
    }, [])

    const getAccountData = async () => {
        setLoadingData(true)
        const data = await axios
            .get(ACCOUNT_ENDPOINTS.ACCOUNT)
            .then((response) => {
                return response.data
            })
            .catch((err) => {
                toastError("Something went wrong, couldn't fetch user data")
                setLoadingData(false)
                // console.log(err);
            })
        if (data) {
            setUserQA(data.securityQuestions)
            setEmail(data.email)
            setFirstName(data.firstName)
            setLastName(data.lastName)
            setMiddleName(data.middleName)
            setPhone(data.phoneNumber)
            setSuffix(data.suffixId)
            setSalutation(data.title)
            setLoadingData(false)
        }
    }

    function validatepassword(paswrd) {
        if (
            /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*\(\)_\+\-=\[\]\{\};':"\\|,.<>\/?~`])(?=.{10,20})/.test(
                paswrd
            )
        ) {
            return false
        } else {
            return true
        }
    }

    const Handleupdate = async (e) => {
        e.preventDefault()
        const cellnumber = phone.replace(/\D/g, '')
        if (firstName === '' || lastName === '' || cellnumber.length === 0) {
            toastError('Please fill all the fields')
            return
        }
        if (cellnumber.length < 10) {
            toastError('Please enter a valid phone number')
            return
        }

        const ePayload = {
            title: salutation,
            email: email,
            firstName: firstName,
            lastName: lastName,
            middleName: middleName,
            suffixId: parseInt(suffix),
            phoneNumber: phone,
            securityQuestions: userQA,
            letterRequestEmailId: 0,
        }

        setLoadingData(true)

        await axios
            .post(ACCOUNT_ENDPOINTS.UPDATEPROFILE, ePayload)
            .then((response) => {
                const user = response.data
                setLoadingData(false)
                toastSuccess('User Data Updated Successfully')
            })
            .catch((err) => {
                setLoadingData(false)
                toastError(
                    err.response.data
                        ? err.response.data
                        : "Something went wrong, couldn't update user data"
                )
                // console.log(err)
            })
    }

    const handleUPQ = async (e) => {
        e.preventDefault()
        let QAtemp = [...userQA]
        userQA.forEach((element) => {
            if (element.loginQAId != 0) {
                QAtemp.push(element)
            }
        })
        setUserQA(QAtemp)

        if (
            question[0].answer === '' ||
            question[1].answer === '' ||
            question[2].answer === ''
        ) {
            toastError('Please Provide Answer')
            return
        }

        const ePayload = [
            {
                loginQuestionId: question[0].loginQuestionId,
                answer: question[0].answer,
            },
            {
                loginQuestionId: question[1].loginQuestionId,
                answer: question[1].answer,
            },
            {
                loginQuestionId: question[2].loginQuestionId,
                answer: question[2].answer,
            },
        ]

        setLoadingData(true)
        await axios
            .post(ACCOUNT_ENDPOINTS.UPDATESECURITYQUESTIONS, ePayload)
            .then((response) => {
                const user = response.data
                toastSuccess('User Questions Updated Successfully')

                // call the function
                getAccountData()
                setLoadingData(false)
                // make sure to catch any error
                // .catch(console.error);
            })
            .catch((err) => {
                setLoadingData(false)
                toastError(
                    err.response.data
                        ? err.response.data
                        : "Something went wrong, couldn't update user questions"
                )
                // console.log(err);
            })
    }

    const handleUP = async (e) => {
        e.preventDefault()

        if (password === '' || password === null) {
            toastError('Password is required.')
            return
        }
        if (password !== passwordAgain) {
            toastError('Passwords do not match. Please try again.')
            return
        }
        if (validatepassword(password)) {
            toastError(
                'Password does not meet the required criteria (see below for the criteria)  Please try again.'
            )
            // setCheckpassword(true)
            return
        }
        // setCheckpassword(false)

        const ePayload = {
            password: password,
        }
        setLoadingData(true)
        await axios
            .post(ACCOUNT_ENDPOINTS.UPDATEPASSWORD, ePayload)
            .then((response) => {
                toastSuccess('User Password Changed successfully')
                setLoadingData(false)
            })
            .catch((err) => {
                setLoadingData(false)
                toastError(
                    err.response.data
                        ? err.response.data
                        : "Something went wrong, couldn't update user password"
                )
                // console.log(err);
            })
    }

    return (
        <>
            <Loader open={loadingData} />

            <Box
                className="section"
                sx={{
                    width: '85%',
                    backgroundColor: '#fff',
                    borderRadius: '5px',
                    boxShadow: '0px 0px 10px rgba(0,0,0,0.1)',
                    padding: '10px 15px',
                }}>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}>
                    <h5 style={{ fontWeight: 600, marginBottom: 1 }}>
                        TMDSAS Evaluator User Account
                    </h5>
                    <p style={{ fontWeight: 600, marginBottom: 0 }}>
                        Your Email: {email}
                    </p>
                    <p>
                        {' '}
                        Please select one of the 3 tabs below to update your
                        account information.
                    </p>
                </div>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="basic tabs example"
                        style={{}}
                        variant="fullWidth">
                        <Tab
                            wrapped
                            label={
                                <Typography
                                    variant="span"
                                    fontSize={'1.2em'}
                                    fontWeight={'bold'}>
                                    Contact Information
                                </Typography>
                            }
                            {...a11yProps(0)}
                        />
                        <Tab
                            wrapped
                            label={
                                <Typography
                                    variant="span"
                                    fontSize={'1.2em'}
                                    fontWeight={'bold'}>
                                    Security Questions
                                </Typography>
                            }
                            {...a11yProps(1)}
                        />
                        <Tab
                            wrapped
                            label={
                                <Typography
                                    variant="span"
                                    fontSize={'1.2em'}
                                    fontWeight={'bold'}>
                                    Password Change
                                </Typography>
                            }
                            {...a11yProps(2)}
                        />
                    </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                    <form
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
                        noValidate
                        autoComplete="off">
                        <p>* denotes required data </p>
                        <Input
                            type="text"
                            name="Salutation"
                            inputStyle={{
                                marginBottom: '10px',
                                Length: 'auto',
                            }}
                            label={'Salutation : '}
                            value={salutation}
                            id="filled-required"
                            onChange={(e) => setSalutation(e.target.value)}
                        />
                        <Input
                            type="text"
                            name="firstname"
                            required
                            inputStyle={{ marginBottom: '10px' }}
                            label={'First name* (20 character maximum) : '}
                            value={firstName}
                            id="firstName"
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                        <Input
                            type="text"
                            name="LastName"
                            required
                            inputStyle={{ marginBottom: '10px' }}
                            label={'last Name*  (30 character maximum) : '}
                            valastnameue={lastName}
                            value={lastName}
                            id="lastName"
                            onChange={(e) => setLastName(e.target.value)}
                        />
                        <Input
                            type="text"
                            name="middleName"
                            inputStyle={{ marginBottom: '10px' }}
                            label={'Middle Name : '}
                            value={middleName}
                            id="middleName"
                            onChange={(e) => setMiddleName(e.target.value)}
                        />
                        <label
                            // style={}
                            // htmlFor={}
                            className="form-label">
                            Suffix:{' '}
                        </label>
                        <Select
                            id="suffix"
                            value={suffix}
                            labelId="suffixId"
                            onChange={(e) => setSuffix(e.target.value)}
                            style={{
                                width: '100%',
                                background: '#f8fafc',
                                height: '2em',
                                minHeight: '2em',
                                marginBottom: '20px',
                            }}>
                            {suffixlist
                                ? suffixlist.map((item) => {
                                      return (
                                          <MenuItem
                                              key={item.suffixId}
                                              value={item.suffixId}>
                                              {item.suffix}
                                          </MenuItem>
                                      )
                                  })
                                : null}
                        </Select>
                        <MaskedInput
                            type="text"
                            id="phone"
                            value={phone}
                            name="Phone"
                            mask="(999) 999-9999"
                            placeholder="(XXX) XXX-XXXX"
                            inputStyle={{ marginBottom: '10px' }}
                            required
                            label={'Mobile Number* : '}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                            }}>
                            <Button variant="contained" onClick={Handleupdate}>
                                {' '}
                                Update user Information
                            </Button>
                        </div>
                    </form>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                    <Box
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                        }}>
                        <p style={{ maxWidth: '100%' }}>
                            Please select 3 of the following questions as your
                            security questions. Should you ever need to reset
                            your password, you will be prompted to answer one of
                            the questions you select and to provide the same
                            answer that you enter now. You will be required to
                            also match the case you type here. You will be able
                            to access your account and change your security
                            questions or your answers at any time. Just click on
                            the My Account link from the homepage.{' '}
                        </p>
                        <p style={{ marginBottom: '5px' }}>Question :</p>
                        <Select
                            id="questionId"
                            value={
                                question[0].loginQuestionId
                                    ? question[0].loginQuestionId
                                    : ''
                            }
                            // label="Question :"
                            labelId="Question"
                            style={{
                                background: '#f8fafc',
                                height: '2em',
                                minHeight: '2em',
                                marginBottom: '10px',
                            }}
                            // onClick={callsuffixes()}

                            onChange={(e) => {
                                const newState = [...question]
                                newState[0] = {
                                    ...newState[0],
                                    loginQuestionId: e.target.value,
                                }
                                setQuestion(newState)
                            }}>
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {questionlist
                                ? questionlist.map((item) => {
                                      if (
                                          item.loginQuestionId ===
                                              question[1].loginQuestionId ||
                                          item.loginQuestionId ===
                                              question[2].loginQuestionId
                                      ) {
                                          item++
                                      } else {
                                          return (
                                              <MenuItem
                                                  key={item.loginQuestionId}
                                                  value={item.loginQuestionId}>
                                                  {item?.loginQuestionDescr}
                                              </MenuItem>
                                          )
                                      }
                                  })
                                : null}
                        </Select>
                        <Input
                            type="text"
                            name="answer"
                            style={{ marginBottom: '10px' }}
                            label={'Answer : '}
                            value={question[0].answer}
                            id="answer"
                            onChange={(e) => {
                                const newState = [...question]
                                newState[0] = {
                                    ...newState[0],
                                    answer: e.target.value,
                                }
                                setQuestion(newState)
                            }}
                        />
                        <p style={{ marginBottom: '5px' }}>Question :</p>
                        <Select
                            id="questionId"
                            value={
                                question[1].loginQuestionId
                                    ? question[1].loginQuestionId
                                    : ''
                            }
                            // label="Question :"
                            labelId="Question"
                            onChange={(e) => {
                                const newState = [...question]
                                newState[1] = {
                                    ...newState[1],
                                    loginQuestionId: e.target.value,
                                }
                                setQuestion(newState)
                                if (
                                    newState[1].loginQuestionId ===
                                    question[0].loginQuestionId
                                ) {
                                    toastError(
                                        'Previouseli selected question select new Question'
                                    )
                                    return
                                }
                            }}
                            style={{
                                background: '#f8fafc',
                                height: '2em',
                                minHeight: '2em',
                                marginBottom: '10px',
                            }}>
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {questionlist
                                ? questionlist.map((item) => {
                                      if (
                                          item.loginQuestionId ===
                                              question[0].loginQuestionId ||
                                          item.loginQuestionId ===
                                              question[2].loginQuestionId
                                      ) {
                                          item++
                                      } else {
                                          return (
                                              <MenuItem
                                                  key={item.loginQuestionId}
                                                  value={item.loginQuestionId}>
                                                  {item?.loginQuestionDescr}
                                              </MenuItem>
                                          )
                                      }
                                  })
                                : null}
                        </Select>
                        <Input
                            type="text"
                            name="answer"
                            style={{ marginBottom: '10px' }}
                            label={'Answer : '}
                            value={question[1].answer}
                            id="answer"
                            onChange={(e) => {
                                const newState = [...question]
                                newState[1] = {
                                    ...newState[1],
                                    answer: e.target.value,
                                }
                                setQuestion(newState)
                            }}
                        />
                        <p style={{ marginBottom: '5px' }}>Question :</p>
                        <Select
                            id="questionId"
                            value={
                                question[2].loginQuestionId
                                    ? question[2].loginQuestionId
                                    : ''
                            }
                            // label="Question :"
                            labelId="Question"
                            onChange={(e) => {
                                const newState = [...question]
                                newState[2] = {
                                    ...newState[2],
                                    loginQuestionId: e.target.value,
                                }
                                setQuestion(newState)
                                if (
                                    newState[2].loginQuestionId ===
                                        question[0].loginQuestionId ||
                                    newState[2].loginQuestionId ===
                                        question[1].loginQuestionId
                                ) {
                                    toastError(
                                        'Previouseli selected question select new Question'
                                    )
                                    return
                                }
                            }}
                            style={{
                                background: '#f8fafc',
                                height: '2em',
                                minHeight: '2em',
                                marginBottom: '10px',
                            }}>
                            <MenuItem value="">
                                <em>None</em>
                            </MenuItem>
                            {questionlist
                                ? questionlist.map((item) => {
                                      if (
                                          item.loginQuestionId ===
                                              question[0].loginQuestionId ||
                                          item.loginQuestionId ===
                                              question[1].loginQuestionId
                                      ) {
                                          item++
                                      } else {
                                          return (
                                              <MenuItem
                                                  key={item.loginQuestionId}
                                                  value={item.loginQuestionId}>
                                                  {item?.loginQuestionDescr}
                                              </MenuItem>
                                          )
                                      }
                                  })
                                : null}
                        </Select>
                        <Input
                            type="text"
                            name="answer"
                            style={{ marginBottom: '10px' }}
                            label={'Answer : '}
                            value={question[2].answer}
                            id="answer"
                            onChange={(e) => {
                                const newState = [...question]
                                newState[2] = {
                                    ...newState[2],
                                    answer: e.target.value,
                                }
                                setQuestion(newState)
                            }}
                        />
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '10px',
                            }}>
                            <Button variant="contained" onClick={handleUPQ}>
                                Update Questions
                            </Button>
                        </div>
                    </Box>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                    <Box
                        style={{
                            display: 'flex',
                            flex: 1,
                            flexDirection: 'column',
                        }}>
                        <p style={{ maxWidth: '100%' }}>
                            The email address below will be used as your login
                            name. This email address will also be used to
                            contact you throughout the application process. This
                            should be an email address that is active and which
                            you check regularly.
                        </p>
                        <div> Email Address : {email} </div>
                        <p style={{ maxWidth: '100%' }}>
                            {' '}
                            Update your <strong>strong password</strong> by
                            meeting the following requirements: At least 1 lower
                            case letter, At least 1 upper case letter, At least
                            1 special character, At least 1 number and At least
                            10 characters in length
                        </p>
                        <Input
                            error
                            type="password"
                            label={'Password'}
                            value={password}
                            id="password"
                            htmlFor="password"
                            onChange={(e) => setPassword(e.target.value)}
                        />

                        {/* {checkpassword ? (
                            <div>
                                <p
                                    style={{
                                        fontSize: 14,
                                        padding: 0,
                                        margin: '5px 0px',
                                        color: 'red',
                                    }}>
                                    {' '}
                                    Password is not strong: it is at least 8
                                    characters long, must contain the following
                                    three: (1) uppercase and (2) lowercase
                                    letters, (3) numbers. Special characters are
                                    allowed.
                                </p>
                            </div>
                        ) : null} */}
                        <Input
                            error
                            type="password"
                            label={'Password Again'}
                            value={passwordAgain}
                            id="passwordagain"
                            htmlFor="passwordagain"
                            onChange={(e) => setPasswordAgain(e.target.value)}
                        />

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginTop: '10px',
                            }}>
                            <Button variant="contained" onClick={handleUP}>
                                Update Password
                            </Button>
                        </div>
                    </Box>
                </CustomTabPanel>
            </Box>
        </>
    )
}
export default Myaccount
